import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=2c6135e3"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=2c6135e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports